"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applicationNestedFields = exports.applicationFlatFields = void 0;
exports.applicationFlatFields = `
  accountNumber
  caseNumber
  correlationId
  customerInformationResponseStatus
  enovaGrant
  r35Status
  resultCode
`;
exports.applicationNestedFields = `
  ${exports.applicationFlatFields}
  agreement {
    applicableForApplicantType
    code
    description
    financingType
    objectGroups {
      code
      name
    }
  }
  calculation {
    administrationFee
    creditCost
    downPayment
    downPaymentPercentage
    duration
    effectiveInterest
    extraEquipmentSubjectToVat
    extraFeeMonthly
    financedAmount
    ignoreCampaigns
    invoiceFee
    monthlyCostServices
    nominalInterest
    price
    registrationFee
    residualValue
    residualValuePercentage
    serviceAgreementPerYearFee
    tireHotelPerYearFee
    totalCost
    totalMonthlyCost
    totalMonthlyCostIncludingServices
    totalPeriodicAmount
    totalPeriodicAmountVat
  }
  coSigner {
    contacts {
      email
      mobilePhone
    }
    firstName
    lastName
  }
  objectRegistry {
    chassisNumber
    initialMileage
    isDirectImport
    isNew
    make
    model
    pricePerAdditionalMile
    registrationNumber
    registrationYear
    yearlyMileage
  }
  primary {
    contacts {
      email
      mobilePhone
    }
    firstName
    lastName
  }
  salesPerson {
    fullName
    id
    username
  }
`;
//# sourceMappingURL=application.js.map